import { Service } from 'typedi';
import { BaseService, IBaseService, ServerResponse } from '../../../core/services/BaseService';
import { BeneficiaryModel, CompareDateModel, DirectDepositModel, FederalTaxWithHoldingModel, OptionSelectionModel, OraUrlModel, PersonalInformationModel, RetirementDateModel, ServiceRetirementSignOffModel, StateTaxWithHoldingModel, StepStatuses, TemporaryAnnuityModel } from './memberCreate/ApplyModels';
import { Appl } from '../../../core/Appl';
// import { OraModel } from './oraTest/OraModel';


export interface IOraService extends IBaseService {

  // getUrl(model: OraModel): Promise<ServerResponse>;
  validateAndVerifyUrl(model: OraUrlModel): Promise<ServerResponse>;
  getSubmissionByMemberIdAsync(memberId: string, formTypeId?: number): Promise<ServerResponse>;
  // getRetirementAppForAdminAsync(submissionId: number): Promise<ServerResponse>;
  // updateRetirementAppForAdminAsync(model: SubmissionModel): Promise<ServerResponse>;

  getDays(date: CompareDateModel): Promise<ServerResponse>;
  createOrUpdateRetirementDateAsync(model: RetirementDateModel): Promise<ServerResponse>;
  getAppForRetirementBySubmissionIdAsync(submissionId: number): Promise<ServerResponse>;
  createOrUpdatePersonalInfoAsync(model: PersonalInformationModel): Promise<ServerResponse>;
  createOrUpdateOptionSelectionAsync(model?: OptionSelectionModel): Promise<ServerResponse>;
  createOrUpdateTemporaryAnnuityAsync(model?: TemporaryAnnuityModel): Promise<ServerResponse>;

  getBeneficiaryAsync(submissionId: number): Promise<ServerResponse>;
  createOrUpdateBeneficiaryAsync(model: BeneficiaryModel): Promise<ServerResponse>;
  deleteBeneficiaryAsync(afrBenId: number): Promise<ServerResponse>;
  setBeneficiaryDesignationMinorChildStatusAsync(submissionId: number, status: string): Promise<ServerResponse>;
  setMemberAggreedDeclarationStatusAsync(submissionId: number, status: string): Promise<ServerResponse>;

  getTaxWithholdingAsync(submissionId: number | undefined): Promise<ServerResponse>;
  createOrUpdateFederalTaxWithholdingAsync(model: FederalTaxWithHoldingModel): Promise<ServerResponse>;

  createOrUpdateStateTaxWithholdingAsync(model: StateTaxWithHoldingModel): Promise<ServerResponse>;

  setTaxWithholdAggreedDeclarationStatusAsync(submissionId: number, agree: boolean): Promise<ServerResponse>;

  getDirectDepositAsync(submissionId: number): Promise<ServerResponse>;
  createOrUpdateDirectDepositAsync(model: DirectDepositModel): Promise<ServerResponse>;

  getServiceRetirementSignOffAsync(submissionId: number): Promise<ServerResponse>;
  createOrUpdateServiceRetirementSignOffAsync(submissionId: number, model: Array<ServiceRetirementSignOffModel>): Promise<ServerResponse>;
  getSubmittedDocumentsAsync(submissionId: number): Promise<ServerResponse>;
  deleteDocumentsAsync(id: number): Promise<ServerResponse>;
  sendDocumentForDocuSignAsync(submissionId: number, name: string): Promise<ServerResponse>;
  submitApplication(submissionId: string, envolopeId: string, documentId: string, status: string): Promise<ServerResponse>;

  updateSelfReviewStatusAsync(submissionId: number, status: string): Promise<ServerResponse>;
  getSubmissionStepStatus(memberId: string): Promise<ServerResponse>;
  updateSubmissionStepStatus(submissionId: number, model: StepStatuses): Promise<ServerResponse>;
}

@Service() // eslint-disable-next-line
export class OraService extends BaseService implements IOraService {
  constructor() {
    super(`${Appl.Setting.Services.RetirementServiceUrl}`);
  }

  // public async getUrl(model: OraModel): Promise<ServerResponse> {
  //   try {
  //     const response = await this.client.post(`/retirement/retiree/afr/url`, model);
  //     return this.getResponse(response);
  //   } catch (error: unknown) {
  //     return await this.getErrorResponse(error);
  //   }
  // }

  public async validateAndVerifyUrl(model: OraUrlModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/retiree/afr/url/memberId`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getSubmissionByMemberIdAsync(memberId: string, formTypeId: number = 1): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/retirement/Submission/SubmissionByMemberId/${memberId}/${formTypeId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  //Apply For Retirement
  public async getAppForRetirementBySubmissionIdAsync(submissionId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/retirement/Retiree/afr/${submissionId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }


  public async getDays(date: CompareDateModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/days/`, date);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async createOrUpdateRetirementDateAsync(model: RetirementDateModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/createOrUpdateRetirementDate`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async createOrUpdatePersonalInfoAsync(model: PersonalInformationModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/CreateOrUpdatePersonalInfo`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async createOrUpdateOptionSelectionAsync(model: OptionSelectionModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/CreateOrUpdateOptionSelection`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async createOrUpdateTemporaryAnnuityAsync(model: TemporaryAnnuityModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/CreateOrUpdateTemporaryAnnuity`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getBeneficiaryAsync(submissionId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/retirement/Retiree/Beneficiary/${submissionId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async createOrUpdateBeneficiaryAsync(model: BeneficiaryModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/CreateOrUpdateBeneficiary`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async deleteBeneficiaryAsync(afrBenId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.delete(`/retirement/Retiree/deleteBeneficiary/${afrBenId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }
  public async setBeneficiaryDesignationMinorChildStatusAsync(submissionId: number, status: string): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/setBeneficiaryDesignationMinorChildStatus/${submissionId}/${status}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async setMemberAggreedDeclarationStatusAsync(submissionId: number, status: string): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/setMemberAggreedDeclarationStatus/${submissionId}/${status}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getTaxWithholdingAsync(submissionId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/retirement/Retiree/TaxWithholding/${submissionId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async createOrUpdateFederalTaxWithholdingAsync(model: FederalTaxWithHoldingModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/CreateOrUpdateFederalTaxWithHolding`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async createOrUpdateStateTaxWithholdingAsync(model: StateTaxWithHoldingModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/CreateOrUpdateStateTaxWithHolding`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async setTaxWithholdAggreedDeclarationStatusAsync(submissionId: number, agree: boolean): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/setTaxWithholdAggreedDeclarationStatus/${submissionId}/${agree}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getDirectDepositAsync(submissionId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/retirement/Retiree/DirectDeposit/${submissionId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async createOrUpdateDirectDepositAsync(model: DirectDepositModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/createOrUpdateDirectDeposit`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getSubmittedDocumentsAsync(submissionId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/retirement/Retiree/SubmittedDocuments/${submissionId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async deleteDocumentsAsync(id: number): Promise<ServerResponse> {
    try {
      const response = await this.client.delete(`/retirement/Retiree/deletedocument/${id}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getServiceRetirementSignOffAsync(submissionId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/retirement/Retiree/ServiceRetirementSignOff/${submissionId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async createOrUpdateServiceRetirementSignOffAsync(submissionId: number, model: Array<ServiceRetirementSignOffModel>): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/createOrUpdateServiceRetirementSignOff/${submissionId}`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async sendDocumentForDocuSignAsync(submissionId: number, name: string): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/send-doc-for-signature/${submissionId}?name=${name}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async submitApplication(submissionId: string, envolopeId: string, documentId: string, status: string): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/submitApplication/${submissionId}?envolopeId=${envolopeId}&documentId=${documentId}&status=${status}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getApplicationContentAsHtmlAsync(submissionId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/retirement/Retiree/getAppContentAsHtml/${submissionId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async updateSelfReviewStatusAsync(submissionId: number, status: string): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/updateSelfReviewStatus/${submissionId}/${status}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

  public async getSubmissionStepStatus(memberId: string): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/retirement/Retiree/getSubmissionStepStatus/${memberId}`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }
  public async updateSubmissionStepStatus(submissionId: number, model: StepStatuses): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/retirement/Retiree/updateSubmissionStepStatus/${submissionId}`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }
}
